import { render, staticRenderFns } from "./GoodsItemMain.vue?vue&type=template&id=92cf65b6&scoped=true"
import script from "./GoodsItemMain.vue?vue&type=script&lang=js"
export * from "./GoodsItemMain.vue?vue&type=script&lang=js"
import style0 from "./GoodsItemMain.vue?vue&type=style&index=0&id=92cf65b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92cf65b6",
  null
  
)

export default component.exports